import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Dropdown, DropdownMenu, DropdownToggle } from 'reactstrap';
import { COLLAPSED_DRAWER, FIXED_DRAWER, HORIZONTAL_NAVIGATION, INSIDE_THE_HEADER } from 'constants/ActionTypes';
import { userSignOut } from 'actions/Auth';
import { markNotificationAsSeen } from 'actions/Notifications';
import { setNewReportDrawerState } from 'actions/NewReport';
import { setNewIssueDrawerState } from 'actions/NewIssue';
import { setGeneralSearchValue, getGeneralSearchResults } from 'actions/GeneralSearch';
import SearchBox from 'components/SearchBox';
import ChatNotifications from './Component/ChatNotifications';
import GeneralNotifications from './Component/GeneralNotifications';
import { switchLanguage, toggleCollapsedNav } from 'actions/Setting';
import IntlMessages from 'util/IntlMessages';
import UserInfo from './Component/UserInfo';
import Menu from './Component/Menu';
import { injectIntl, intlShape } from 'react-intl';
import UserAvatar from 'components/UserAvatar';
import { startIntroTour } from 'actions/Intro';
import swal from 'sweetalert';

class Header extends React.Component {
	onAppNotificationSelect = () => {
		this.setState({
			appNotification: !this.state.appNotification
		});
	};

	onChatNotificationSelect = () => {
		this.setState({
			chatNotification: !this.state.chatNotification
		});
	};

	onUserInfoSelect = () => {
		this.setState({
			userInfo: !this.state.userInfo
		});
	};

	onLangSwitcherSelect = event => {
		this.setState({
			langSwitcher: !this.state.langSwitcher
		});
	};

	onSearchBoxSelect = () => {
		this.setState({
			searchBox: !this.state.searchBox
		});
	};

	handleRequestClose = () => {
		this.setState({
			langSwitcher: false,
			chatNotification: false,
			appNotification: false,
			searchBox: false
		});
	};

	onToggleCollapsedNav = e => {
		const val = !this.props.navCollapsed;
		this.props.toggleCollapsedNav(val);
	};

	constructor() {
		super();
		this.state = {
			searchBox: false,
			searchText: '',
			chatNotification: false,
			langSwitcher: false,
			appNotification: false,
			userInfo: false,
			showNewReportForm: false
		};
	}

	toReport = (reportId, notificationId, chatId) => {
		this.props.markNotificationAsSeen(notificationId);
		this.props.history.push(`/app/report/${reportId}/${chatId ? `chat/${chatId}` : ''}`);
	};

	toReference = (link, notificationId) => {
		this.props.markNotificationAsSeen(notificationId);

		// if (this.props.organisationId === 29) {
		// 	this.props.history.push(`/app/${link.replace('report/', 'issue/')}`); // ----------------- Nur für Beschwerdemanagement RD ECK ---------------------
		// } else {
		this.props.history.push(`/app/${link}`);
		// }
	};

	onInvalidClick = (notificationId, reportId) => {
		this.props.markNotificationAsSeen(notificationId);
		swal({
			title: this.props.intl.formatMessage({ id: 'header.notifications.invalidNotification.title' }),
			text: this.props.intl.formatMessage({ id: 'header.notifications.invalidNotification.text' }),
			icon: 'warning',
			buttons: [this.props.intl.formatMessage({ id: 'common.close' }), false]
		});
	};

	doSearch(searchValue) {
		if (this.props.history.location.pathname !== '/app/search') this.props.history.push('/app/search');
		this.props.getGeneralSearchResults(searchValue);
	}

	renderTourStartButton(page) {
		// Intro Tour Button nur auf den folgenden Seiten anzeigen
		if (page == 'dashboard' || page === 'report-table' || page === 'report-map' || page === 'report-archive' || page === 'report') {
			return (
				<ul className="header-notifications list-inline mr-auto">
					<li className="list-inline-item">
						<span className="d-inline-block" onClick={() => this.props.startIntroTour(page)}>
							<span className="icon-btn size-20 font-size-16">
								<i className="zmdi zmdi-help-outline zmdi-hc-2x mt-2" />
							</span>
						</span>
					</li>
				</ul>
			);
		}
		return null;
	}

	render() {
		const { drawerType, locale, userProfile, searchValue } = this.props;

		const drawerStyle = drawerType.includes(FIXED_DRAWER) ? 'd-flex d-xl-none' : drawerType.includes(COLLAPSED_DRAWER) ? 'd-flex' : 'd-none';
		const routeArray = this.props.location.pathname ? this.props.location.pathname.split('/') : [];
		return (
			<div className="app-main-header">
				<div className="d-flex app-toolbar align-items-center">
					<span className={`jr-menu-icon pointer ${drawerStyle}`} onClick={this.onToggleCollapsedNav}>
						<span className="menu-icon" />
					</span>
					<div className="d-flex">
						{this.renderTourStartButton(routeArray[2])}
						{
							<SearchBox
								styleName="d-none d-lg-block ml-2"
								onChange={m => this.props.setGeneralSearchValue(m.target.value)}
								value={searchValue}
								placeholder={this.props.intl.formatMessage({
									id: 'header.search.placeholder'
								})}
								onKeyUp={e => {
									if (e.key === 'Enter') this.doSearch(searchValue);
								}}
							/>
						}
					</div>
					<ul className="header-notifications list-inline ml-auto">
						{this.props.userProfile.replacementActive && (
							<li className="list-inline-item">
								<span
									className="d-inline-block"
									onClick={() => this.props.history.push(`/app/user/${this.props.userProfile.userId}/edit/settings`)}
								>
									<span className="icon-btn size-20 font-size-16 text-orange">
										<i className="zmdi zmdi-flight-takeoff zmdi-hc-lg" />
									</span>
								</span>
							</li>
						)}

						{this.props.navigationSettings.newReportForm && this.props.userProfile.modules.reports && (
							<li className="list-inline-item tour-dashboard-step-4">
								<span className="d-inline-block" onClick={() => this.props.setNewReportDrawerState(!this.props.newReportDrawerState)}>
									<span className="icon-btn size-20 font-size-16" title="Neue Meldung erstellen">
										<i className="zmdi zmdi-plus zmdi-hc-lg" />
									</span>
								</span>
							</li>
						)}

						{this.props.navigationSettings.newReportForm && this.props.userProfile.modules.issues && (
							<li className="list-inline-item tour-dashboard-step-4">
								<span className="d-inline-block" onClick={() => this.props.setNewIssueDrawerState(!this.props.newIssueDrawerState)}>
									<span className="icon-btn size-20 font-size-16" title="Neues Anliegen erstellen">
										<i className="zmdi zmdi-plus zmdi-hc-lg" />
									</span>
								</span>
							</li>
						)}

						<li className="list-inline-item tour-dashboard-step-5">
							<Dropdown className="quick-menu" isOpen={this.state.appNotification} toggle={this.onAppNotificationSelect.bind(this)}>
								<DropdownToggle className="d-inline-block" tag="span" data-toggle="dropdown">
									<span className="icon-btn size-20 font-size-16">
										<i
											className={`zmdi zmdi-notifications-active zmdi-hc-lg ${
												this.props.notifications.generalNotifications.filter(notification => notification.highlighted)
													.length > 0
													? 'icon-alert'
													: ''
											}`}
										/>
									</span>
								</DropdownToggle>

								<DropdownMenu right>
									<div className="jr-card-header d-flex align-items-center">
										<div className="mr-auto">
											<h3 className="card-heading mb-0">
												<IntlMessages id="header.generalNotifications.title" />
											</h3>
										</div>

										<small
											className="text-blue pointer"
											onClick={() =>
												this.props.notifications.generalNotifications
													.filter(n => n.highlighted)
													.map(n => this.props.markNotificationAsSeen(n.notificationId))
											}
										>
											<IntlMessages id="header.markNotificationsAsSeen" />
										</small>
									</div>
									<GeneralNotifications
										notifications={this.props.notifications.generalNotifications}
										toReference={this.toReference}
										reports={this.props.reportList}
										onInvalidClick={this.onInvalidClick}
									/>
								</DropdownMenu>
							</Dropdown>
						</li>
						<li className="list-inline-item tour-dashboard-step-6">
							<Dropdown className="quick-menu" isOpen={this.state.chatNotification} toggle={this.onChatNotificationSelect.bind(this)}>
								<DropdownToggle className="d-inline-block" tag="span" data-toggle="dropdown">
									<span className="icon-btn size-20 font-size-16">
										<i
											className={`zmdi zmdi-comment-alt-text zmdi-hc-lg ${
												this.props.notifications.chatNotifications.filter(notification => notification.highlighted).length > 0
													? 'icon-alert'
													: ''
											}`}
										/>
									</span>
								</DropdownToggle>

								<DropdownMenu right>
									<div className="jr-card-header d-flex align-items-center">
										<div className="mr-auto">
											<h3 className="card-heading mb-0">
												<IntlMessages id="header.chatNotifications.title" />
											</h3>
										</div>

										<small
											className="text-blue pointer"
											onClick={() =>
												this.props.notifications.chatNotifications
													.filter(n => n.highlighted)
													.map(n => this.props.markNotificationAsSeen(n.notificationId))
											}
										>
											<IntlMessages id="header.markNotificationsAsSeen" />
										</small>
									</div>
									<ChatNotifications
										notifications={this.props.notifications.chatNotifications}
										toReference={this.toReference}
										reports={this.props.reportList}
										onInvalidClick={this.onInvalidClick}
									/>
								</DropdownMenu>
							</Dropdown>
						</li>
						<li className="list-inline-item user-nav tour-dashboard-step-7">
							<Dropdown className="quick-menu" isOpen={this.state.userInfo} toggle={this.onUserInfoSelect.bind(this)}>
								<DropdownToggle className="d-inline-block" tag="span" data-toggle="dropdown">
									<UserAvatar avatar={userProfile.avatar} size={30} fontSize={14} style="pointer" />
								</DropdownToggle>
								<DropdownMenu right>
									<UserInfo
										user={userProfile}
										onSignOut={() => this.props.userSignOut()}
										toUserProfile={() => {
											this.setState({ userInfo: false });
											this.props.history.push(`/app/user/${userProfile.userId}`);
										}}
										toUserSettings={() => {
											this.setState({ userInfo: false });
											this.props.history.push(`/app/user/${userProfile.userId}/edit/settings`);
										}}
									/>
								</DropdownMenu>
							</Dropdown>
						</li>
					</ul>
				</div>
			</div>
		);
	}
}

const mapStateToProps = ({ auth, settings, profile, notifications, newReport, newIssue, generalSearch, reports, accountSettings }) => {
	const { authUser } = auth;
	const { drawerType, locale, navigationStyle, horizontalNavPosition } = settings;
	const { navigation, organisationId } = accountSettings.organisationStructure;
	return {
		drawerType,
		locale,
		navigationStyle,
		horizontalNavPosition,
		userProfile: profile.myUserProfile,
		notifications,
		authUser,
		newReportDrawerState: newReport.drawerState,
		newIssueDrawerState: newIssue.drawerState,
		searchValue: generalSearch.searchValue,
		reportList: reports.reports,
		navigationSettings: navigation,
		organisationId
	};
};

Header.propTypes = {
	intl: intlShape.isRequired
};

export default withRouter(
	connect(
		mapStateToProps,
		{
			toggleCollapsedNav,
			switchLanguage,
			userSignOut,
			markNotificationAsSeen,
			setNewReportDrawerState,
			setGeneralSearchValue,
			getGeneralSearchResults,
			startIntroTour,
			setNewIssueDrawerState
		}
	)(injectIntl(Header))
);



// WEBPACK FOOTER //
// ./containers/Header/index.js